<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  // components: {
  //   Home
  // },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy: function() {},
  methods: {}
}
</script>
<style></style>
